/* eslint-disable */
import type { Version } from "../cash/clients/VersionProto.pb";

/**
 * AppSupport will be used to define which version of the app each component
 * in the BorrowConfig supports. When AppSupport is null on any component,
 * it supports any version/platform combination.
 *
 * Note that [min_version] is inclusive, while [max_version] is exclusive.
 */
export interface AppSupport {
  /** The client platform(s) supported. This AppSupport will be ignored if this is empty. */
  platform?: AppSupportPlatform[];
  /**
   * The minimum version supported, **inclusive**. Optional; if null then all versions below
   * [max_version] are supported.
   */
  min_version?: Version;
  /**
   * The maximum version supported, **exclusive**. Optional; if null then all versions
   * [min_version] and above are supported.
   */
  max_version?: Version;
}

export enum AppSupportPlatform {
  IOS = "IOS",
  ANDROID = "ANDROID",
}
